import { BaseAction } from "../../../core/actions/BaseAction";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IShouldRenderFieldAction } from "../../../Orchestrator/Types/Interface/ActionParams/ServiceRequestActionParams";

class ShouldRenderFieldAction extends BaseAction<IDefaultActionResult, IShouldRenderFieldAction> {

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: false,
            message: "",
            status: "fail"
        }
        try {
            const { field, additionalFields, formData } = this.params!
            if (!field.conditions) actionResult.data = true;
            actionResult.data = field.conditions.every((condition) => {
                const conditionWhenFiledId = additionalFields.find(
                    (conFiled) => conFiled.title === condition.when
                )?.fieldId;
                if (conditionWhenFiledId) {
                    return formData[conditionWhenFiledId] === condition.match;
                }
                return false
            });
            actionResult.status = "success"
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const shouldRenderFieldAction = new ShouldRenderFieldAction()